import { render } from "./AppAccountDropdown.vue?vue&type=template&id=56ce2ffd"
import script from "./AppAccountDropdown.vue?vue&type=script&lang=ts"
export * from "./AppAccountDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnDropdown,QList,QItem,QItemSection,QIcon});qInstall(script, 'directives', {ClosePopup});
